// @flow

export default {
  UPLOAD: 'UPLOAD',
  PURCHASE: 'PURCHASE',
}
